<script setup lang="ts">
import { getClasses } from '~/js/composables/classes'

import TextProse from '~/vue/atoms/texts/TextProse.vue'

interface Props {
    message: string|null
    utilities?: string
}

withDefaults(defineProps<Props>(), {
    utilities: ''
})

const emit = defineEmits(['action'])

const classes = {
    wrapper: {
        display: 'flex items-center justify-center p-4',
        span: 'lg:col-span-2',
    },
    container: {
        color: 'text-gray-700',
        alignment: 'text-left',
        size: 'w-full',
    }
}

</script>
<template>
    <div
        role="alertdialog"
        aria-labelby="alert-tile"
        aria-describedby="alert-message"
        :class="[getClasses(classes, 'wrapper'), utilities]"
    >
        <div :class="getClasses(classes, 'container')">
            <!-- Message -->
            <div id="alert-message" class="prose">
                <TextProse>
                    <span v-html="message" />
                </TextProse>
            </div>
        </div>
    </div>

</template>